<template>
  <div class="app-container forgot-password-content">
    <div v-if="isMobile === false" v-loading.fullscreen="loading" element-loading-background="rgba(80, 80, 80, 0.8)">
      <div class="box-card forgot-password-header">
        <div class="forgot-password-header-info">
          <img :src="ieshopLogo" style="height: 60px;">
          <p class="page-title">Forgot password?</p>
        </div>
      </div>
      <div class="box-card forgot-password-info">
        <el-form class="pc-form" :model="shopForm" :rules="rules" ref="ruleForm">
          <el-form-item class="pc-form-item" label="Email address" prop="shop_admin_email">
            <el-input
              class="pc-form-input"
              v-model="shopForm.shop_admin_email"
              placeholder="Enter your email"
            ></el-input>
          </el-form-item>
          <div style="text-align: center;">
            <el-button
              @click="resetPassword()"
              class="btn"
            >Reset Password</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div v-else class="forgot-password-mobile" v-loading.fullscreen="loading" element-loading-background="rgba(80, 80, 80, 0.8)">
      <div class="box-card mobile-header">
        <div class="forgot-password-header-info">
          <img :src="ieshopLogo" style="height: 45px;">
          <div class="page-title">Forgot password?</div>
        </div>
      </div>
      <div class="box-card mobile-forgot-password-info">
        <el-form :model="shopForm" :rules="rules" ref="ruleForm" style="width: 100%;">
          <el-form-item prop="shop_admin_email">
            <el-input
              v-model="shopForm.shop_admin_email"
              placeholder="Enter your email"
            ></el-input>
          </el-form-item>
          <div style="margin-top: 20px; text-align: center;">
            <el-button
              @click="resetPassword()"
              class="mobile-btn"
            >Reset Password</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <el-dialog class="pc-dialog" title="Successfully" :visible.sync="forgotPasswordSuccessVisible" width="40%" v-if="isMobile === false">
      <div class="dialog-content">
        <i class="el-icon-success success-icon" />
        <span class="email-sent"> Reset password email has been sent!</span>
      </div>
      <div class="check-email">
        Please check it in your Email.
      </div>
      <div class="confirm-button">
        <el-button
          class="btn"
          type="primary"
          @click="confirmEmail"
        >Confirm</el-button>
      </div>
    </el-dialog>
    <el-dialog class="mobile-dialog" title="Successfully" :visible.sync="forgotPasswordSuccessVisible" width="90%" v-else>
      <div class="dialog-content">
        <i class="el-icon-success success-icon" />
        <span class="email-sent"> Reset password email has been sent!</span>
      </div>
      <div class="check-email">
        Please check it in your Email.
      </div>
      <div class="confirm-button">
        <el-button
          class="btn"
          type="primary"
          @click="confirmEmail"
        >Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import ieshopLogo from '@/assets/img/ieshop_logo.png'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      ieshopLogo: ieshopLogo,
      isMobile: false,
      shopForm: {
        shop_admin_email: ''
      },
      forgotPasswordSuccessVisible: false,
      loading: false,
      rules: {
        shop_admin_email: [
          {
            required: true,
            min: 6,
            message: 'Please input Email',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.checkMobile()
  },
  methods: {
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
      console.log(this.isMobile)
    },
    resetPassword() {
      const emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      // 如果邮箱格式错误
      if (!emailPattern.test(this.shopForm.shop_admin_email)) {
        this.$message({
          message: 'Invalid email format',
          type: 'warning'
        })
        return
      }
      // this.forgotPasswordSuccessVisible = true
      this.loading = true

      // var data = {
      //   email: this.shopForm.shop_admin_email
      // }

      request({
        url: '/password-recovery/email',
        method: 'get',
        params: {
          email: this.shopForm.shop_admin_email
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.forgotPasswordSuccessVisible = true
            this.shopForm.shop_admin_email = ''

            this.loading = false
          } else {
            this.$message.error(res.error)
            this.loading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('Reset password failed')
          this.loading = false
        })
    },
    confirmEmail() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({
          path: '/login'
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.page-title {
  margin-top: 50px;
  font-size: 28px;
  color: #fff;
}

.forgot-password-content {
  background-color: #212326;
  background-size: cover;
  min-height: 100vh;
}
.forgot-password-header {
  padding-top: 80px;
  width: 80%;
  margin: 0px auto;
  // margin-top: 20px;
}
.forgot-password-info {
  width: 80%;
  margin: 20px auto;
}
.forgot-password-header-info {
  margin-top: 10px;
  text-align: center;
}
.mobile-header {
  padding-top: 30px;
  width: 100%;
  margin: 0px auto;
  margin-top: 30px;
}
.mobile-forgot-password-info {
  width: 100%;
  margin: 20px auto;
}
.btn {
  // width: 150px;
  margin-top: 30px;
  padding: 12px 50px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(45deg, #719E41, #6D9B3F);
  color: #fff !important;
  border: none;
}
.mobile-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(45deg, #719E41, #6D9B3F);
  color: #fff !important;
  border: none;
}
.pc-form {
  width: 60%;
  padding-top: 5px;
  margin: 0 auto;
}
.pc-form-item {
  text-align: center;
}
.pc-form-input {
  max-width: 100%;
  height: 50px;
  line-height: 50px;
}
.pc-dialog {
  .dialog-content {
    padding: 0 30px;

    .success-icon {
      color: #67C23A;
      font-size: 28px;
    }
    .email-sent {
      color: #67C23A;
      font-size: 28px;
      word-break: normal;
    }
  }
  .check-email {
    padding: 30px;
    font-size: 18px;
    line-height: 36px;
    color: #fff;
    word-break: normal;
  }
  .confirm-button {
    margin-top: 10px;
    text-align: center;
  }
}
.mobile-dialog{
  .dialog-content {
    padding: 0 30px;

    .success-icon {
      color: #67C23A;
      font-size: 22px;
    }
    .email-sent {
      color: #67C23A;
      font-size: 22px;
      word-break: normal;
    }
  }
  .check-email {
    padding: 20px 30px;
    font-size: 16px;
    line-height: 26px;
    color: #fff;
    word-break: normal;
  }
  .confirm-button {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
<style type="text/css">
.forgot-password-content .el-form-item__label {
  color: #fff;
  font-size: 16px;
}
.forgot-password-content .el-form-item__error {
  color: #ccc;
}
.forgot-password-content .el-input__inner {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
}
.forgot-password-content .el-dialog {
  background-color: #212326;
}
.forgot-password-content .el-dialog__title {
  color: #fff;
}
.forgot-password-content .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
